/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { rowSpacing, enterpriseCSS } from './variables';

export const innerModal = (typography, palette) => ({
    innerModal: {
        // height: 'calc(100vh - 250px)',
        width: `calc(100vw - ${rowSpacing * 2}px)`,
        padding: rowSpacing,
        display: 'flex',
        flexWrap: 'wrap',
        flexFlow: 'row wrap',
        overflowY: 'scroll',
        alignItems: 'center',
        alignContent: 'flex-start',
        flexDirection: 'row',
        justifyContent: 'left',
        backgroundColor: palette.common?.white,
        margin: 'auto',
        borderRadius: '4px',
        outline: 'none',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        top: '50%',
        left: '50%',

        '&.dialog': {
            padding: '24px 0px',
            width: 950,
            '@media (min-width: 768px) and (max-width: 1000px)': {
                width: 500,
                overflow: 'auto',
            },
            '@media (max-width: 767px)': {
                width: `calc(100vw - ${rowSpacing * 2}px)`,
            },
            '@media (max-width: 1023px)': {
                padding: '24px 24px',
            },

            '&.desktop': {
                'overflow-y': 'auto',
                'max-width': '1024px',
                paddingTop: 0,
                borderRadius: 0,
                '&.wide': {
                    width: '800px !important',
                },
                '&.smallWidth': {
                    top: '50%',
                    '@media (min-width: 768px) and (max-width: 1023px)': {
                        top: '35%',
                    },
                },
                '& .mainBillingCard': {
                    marginTop: 22, // TODO
                    position: 'relative',
                    display: 'block',
                    overflow: 'hidden',
                    minHeight: '400px',
                    '&.no-card-info': {
                        '& .billRigthtSide': {
                            width: '680px !important',
                            float: 'none',
                            margin: '0 auto',
                        },
                    },
                    '& .buttonForm': {
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                    },
                    '& .checkbox-selecter': {
                        paddingLeft: 0,
                    },
                },
                '&.compare-2-products': {
                    width: 234 * 2 + 24 + 48,
                },
                '&.compare-3-products': {
                    width: 234 * 3 + 24 * 2 + 48,
                },
                '&.compare-4-products': {
                    'max-width': 234 * 4 + 24 * 3 + 48,
                    'min-width': 234 * 4 + 24 * 3 + 48,
                },

                '& .modal-title': {
                    padding: `10px ${rowSpacing * 2}px`,
                    width: '100%',
                    backgroundColor: enterpriseCSS.palette.modal.title.backgroundColor,

                    '& h2': {
                        color: `${enterpriseCSS.palette.modal.title.color} !important`,
                        fontSize: enterpriseCSS.palette.modal.title.size,
                    },
                    '& .x-icon': {
                        cursor: 'pointer',
                    },
                },

                '& .modal-content-wrapper': {
                    'overflow-y': 'auto',
                },
            },

            '&.no-x-button .modal-title .x-icon': {
                display: 'none',
            },

            '& button span:first-child': {
                maxWidth: 'calc(100vw - (12px + 24px + 16px) * 2)',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                display: 'inline-block',
            },

            '&.small-dailog': {
                width: '100%',
                maxWidth: '450px',
                marginLeft: 'auto',
                marginRight: 'auto',
                overflow: 'hidden',
                borderRadius: 0,
                '@media (min-width: 768px) and (max-width: 1366px)': {
                    top: '45%',
                    padding: '12px',
                },
                '& p': {
                    textAlign: 'center',
                    fontSize: '18px',
                    '&.left': {
                        textAlign: 'left',
                    },
                    '&.bodySize': {
                        fontSize: 14,
                    },
                },
                '& .modal-content-wrapper': {
                    overflow: 'hidden',
                },
                '& .empty-title >svg': {
                    display: 'none',
                },
                '& .buttonForm': {
                    borderTop: 'unset',
                    '& .buttonDelete': {
                        float: 'unset',
                    },
                    '& .buttonCancel': {
                        float: 'unset',
                    },
                    '& button': {
                        marginRight: 0,
                        width: '135px',
                    },
                },
                '& .desktop-dialog-btn-wrapper': {
                    textAlign: 'center',
                    paddingTop: rowSpacing * 2,
                },
                '&:not(.HD) button': {
                    minWidth: 100,
                    borderRadius: '2px !important',
                    color: palette.common?.white,
                    border: `1px solid ${enterpriseCSS.palette.darkRed}`, // TODO
                    fontSize: '1em',
                    textTransform: 'capitalize',
                    fontWeight: 'bold',
                    backgroundColor: enterpriseCSS.palette.darkRed,
                    '&:hover': {
                        color: palette.common?.white,
                        border: `1px solid ${enterpriseCSS.palette.hoverRed}`, // TODO
                        backgroundColor: enterpriseCSS.palette.hoverRed,
                    },
                    '&.red': {
                        border: `1px solid ${palette.snipeTextPromo}`, // TODO
                        backgroundColor: palette.snipeTextPromo, // TODO
                        '&:hover': {
                            backgroundColor: palette.snipeTextPromo, // TODO
                        },
                    },
                    '&.secondary': {
                        backgroundColor: palette.common?.white,
                        color: enterpriseCSS.palette.button.darkGray, // TODO
                        border: `1px solid ${enterpriseCSS.palette.button.darkGray}`, // TODO
                        '&:hover': {
                            backgroundColor: enterpriseCSS.palette.button.darkGray,
                            color: enterpriseCSS.palette.white, // TODO
                            border: `1px solid ${enterpriseCSS.palette.button.darkGray}`,
                        },
                    },
                },
                '&.HD button': {
                    fontFamily: typography.fontFamily,
                    boxSizing: 'border-box',
                    WebkitFontSmoothing: 'antialiased',
                    fontWeight: '700',
                    width: 'auto',
                    minWidth: 120,
                    fontSize: '1em',
                    textTransform: 'none',
                    borderRadius: '20px',
                    padding: '6px 40px',
                    boxShadow: 'none',
                    // primary button
                    color: palette.common?.white,
                    backgroundColor: `${palette.primaryButton}`,
                    border: `1px solid ${palette.primaryButton}`,
                    '&:hover': {
                        color: `${palette.common?.white} !important`, // TODO
                        border: `1px solid ${palette.cms?.primary_hover}` || 'd73833',
                        backgroundColor: palette.cms?.primary_hover || 'd73833', // TODO
                    },
                    '&[disabled]': {
                        color: palette.grey8, // TODO
                        border: `1px solid ${palette.grey['300']}`, // TODO
                        backgroundColor: palette.grey['300'], // TODO
                    },
                    // secondary button
                    '&.secondary': {
                        color: palette.cms?.secondary,
                        backgroundColor: palette.common?.white,
                        border: `1px solid ${palette.cms?.secondary}`,
                        '&:hover': {
                            color: palette.common?.white,
                            border: `1px solid ${palette.cms?.secondary}`,
                            backgroundColor: palette.cms?.secondary,
                        },
                        '&[disabled]': {
                            color: palette.grey8,
                            border: `1px solid ${palette.grey['300']}`,
                            backgroundColor: palette.grey['300'],
                        },
                    },
                    '&.tertiary': {
                        color: palette.common?.white,
                        backgroundColor: palette.cms?.tertiary_font_color,
                        border: `1px solid ${palette.cms?.tertiary_font_color}`,
                        '&:hover': {
                            color: palette.common?.white, // TODO
                            border: `1px solid ${palette.cms?.tertiary_hover}`, // TODO
                            backgroundColor: palette.cms?.tertiary_hover, // TODO
                        },
                        '&[disabled]': {
                            color: palette.grey8, // TODO
                            border: `1px solid ${palette.grey['300']}`, // TODO
                            backgroundColor: palette.grey['300'], // TODO
                        },
                    },
                },
            },

            '&.headless': {
                '& .modal-title': {
                    display: 'none',
                },
                '& .modal-content-wrapper': {
                    marginTop: rowSpacing * 2,
                },
            },
        },

        '&.has-footer-content-inside': {
            backgroundColor: 'transparent',
            padding: 0,
            width: `calc(100vw - ${rowSpacing * 2}px)`,
            'overflow-x': 'hidden',

            '& .modal-title': {
                backgroundColor: palette.common?.white,
                padding: rowSpacing,
                paddingBottom: `${rowSpacing * 2}px`,
                marginBottom: '-1px', // Fix 1 px spacing below the title caused by overflow-x: hidden;
            },

            '& .modal-content': {
                backgroundColor: palette.common?.white,
                marginLeft: 0,
                'border-bottom-left-radius': '4px',
                'border-bottom-right-radius': '4px',
                maxHeight: `calc(100vh - ${rowSpacing * 20}px - 50px)`,
                minWidth: `calc(100vw - ${rowSpacing * 20}px)`,
            },
            '& .carousel-container': {
                marginBottom: rowSpacing,
                minHeight: '320px',
            },
            '& .shop-the-site-wrapper': {
                '& h2': { color: `${palette.common?.white} !important` },
            },
        },

        '& .max-width-100vw': { 'max-width': '100vw' },

        '& .modal-title': {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            paddingBottom: rowSpacing,
            '&.empty-title': {
                paddingBottom: 0,
            },

            '& > *:not(svg)': { flex: 1 },
        },

        '& .modal-content-wrapper': {
            width: '100%',
            'max-height': `calc(100vh - ${rowSpacing * 12}px)`,
            '@media (min-width: 768px)': {
                overflow: 'auto',
            },
            '@media (min-width: 1023px)': {
                padding: '0px 24px',
            },
            '@media (max-width: 767px)': {
                'overflow-y': 'scroll',
                'overflow-x': 'hidden',
            },
            '& .modal-error-icon': {
                float: 'left',
                color: enterpriseCSS.palette.error,
                width: `${rowSpacing * 4}px`,
                height: `${rowSpacing * 4}px`,
                marginRight: `${rowSpacing}px`,
            },
            '& > p:last-child': {
                marginBottom: 0,
            },
        },

        '& .modal-content-wrapper.RecipientDetails': {
            padding: '0px',
        },

        '& .modal-content-wrapper.RecipientDetails img': {
            width: '100%',
        },

        '& .modal-content': {
            'max-width': `calc(100vw - ${rowSpacing * 2}px)`,
            'margin-left': `${rowSpacing * -1}px`,
            'overflow-x': 'hidden',
            'max-height': `calc(100vh - ${rowSpacing * 20}px)`,
            'min-height': `${rowSpacing * 10}px`,

            '& > *': {
                'margin-left': rowSpacing,
                'margin-right': rowSpacing,
            },
        },

        '& .product-content-ul': {
            'max-height': '340px',
            'overflow-y': 'scroll',
        },
    },

    giftListUserV2: {
        display: 'block',
        '& .desktop.HD .removeButton': {
            textAlign: 'left',
            fontSize: '16px',
            fontStyle: 'normal',
            lineHeight: '24px',
            letterSpacing: '0.64px',
            textTransform: 'capitalize',
            border: '0px',
            padding: '0px',
            background: 'transparent',
            color: '#DF3030',
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            '&:hover': {
                background: 'transparent',
                color: '#DF3030',
                padding: '0px',
                border: '0px',
            },
            '& .MuiTouchRipple-root span': {
                display: 'none !important',
            },
            '@media only screen and (max-width: 600.5px) ': {
                width: '100%',
            },
        },
        '& $innerModal': {
            '@media (max-width: 1000.5px)': {
                width: `calc(100vw - ${rowSpacing * 3}px)`,
                display: 'block',
            },
            '& .split': {
                '@media only screen and (max-width: 600.5px)': {
                    display: 'block',
                },
                '& .input-password-width': {
                    width: '100%',
                },
                '&.cityContainer': {
                    display: 'flex',
                },
            },
            '& button span:first-child': {
                whiteSpace: 'unset',
            },
            '& .locationSelect': {
                display: 'none',
            },
            '& .locationType': {
                marginRight: '0px',
            },
        },
        '& .dialog': {
            '& p': {
                '&.bodySize': {
                    fontSize: '1.125rem !important',
                    lineHeight: '1.75rem',
                    textAlign: 'center !important',
                    padding: '0px 45px',
                    '@media only screen and (max-width: 1439.5px) ': {
                        padding: '0px 38px',
                    },
                    '@media only screen and (max-width: 1023.5px) ': {
                        fontSize: '1rem !important',
                        lineHeight: '1.50rem',
                    },
                },
                '& .link': {
                    fontSize: '1.125rem ',
                    lineHeight: '1.75rem',
                    '@media only screen and (max-width: 1023.5px) ': {
                        fontSize: '1rem',
                        lineHeight: '1.50rem',
                    },
                },
            },
            '& .locationType': {
                display: 'block',
            },
            '& .DesktopAddressForm': {
                display: 'block',
                margin: '10px 0px 0px',
                '& ..MuiTabs-flexContainer': {
                    padding: '12px 0px 0px',
                },
                '& .tabButton': {
                    fontSize: '1rem',
                    lineHeight: '1.5rem',
                    fontWeight: 400,
                    maxWidth: '50% ',
                    width: '50% ',
                    backgroundColor: 'inherit !important',
                    color: palette.cms?.black || '#2f2f2f !important',
                    borderRadius: '0px',
                    border: 'inherit !important',
                    fontFamily: 'LatoRegular',
                    borderBottom: `1px solid ${palette.cms?.black || '#2f2f2f !important'}`,
                    padding: '12px 13px',
                    opacity: 1,
                    '@media only screen and (max-width: 600.5px) ': {
                        padding: '0px',
                        width: '48%',
                        maxWidth: '48%',
                        minWidth: 'auto',
                    },
                },
                '& .activeTab': {
                    fontWeight: 700,
                    color: palette.cms?.green || '#387154 !important',
                    borderBottom: `3px solid ${palette.cms?.green || '#387154 !important'}`,
                },
            },
            '& .DesktopAddressRemove': {
                maxHeight: '100%',
            },
            '&.desktop': {
                '& .modal-title': {
                    backgroundColor: palette.cms?.white || '#ffffff',
                    boxShadow: '0px 3px 3px rgb(47 47 47 / 15%)',
                    color: palette.cms?.black || '#2f2f2f',
                    '& h2': {
                        color: palette.cms?.black || '#2f2f2f !important',
                        fontSize: '1.25rem',
                        lineHeight: '1.75rem',
                    },
                },
                '& button': {
                    '@media only screen and (max-width: 600.5px) ': {
                        width: '50%',
                        minWidth: 'auto',
                        padding: '11px 10px !important',
                    },
                },
                '& .submitButton': {
                    '&[disabled]': {
                        backgroundColor: palette.grey?.['300'] || '#E0E0E0',
                        border: `1px solid ${palette.grey?.['300'] || '#E0E0E0'}`,
                    },
                    borderRadius: 'inherit',
                    color: palette.cms?.white || '#ffffff',
                    backgroundColor: palette.cms.black || '#2f2f2f',
                    lineHeight: '20px',
                    border: `1px solid ${palette.cms?.black || '#2f2f2f'}`,
                    margin: '0px',
                    padding: '8px 20px',
                    textTransform: 'capitalize',
                    '&:hover': {
                        backgroundColor: palette.cms.black || '#2f2f2f',
                        border: `1px solid ${palette.cms?.black || '#2f2f2f '}`,
                        color: palette.cms?.white || '#ffffff',
                    },

                },
                '& .cancelButton': {
                    borderRadius: 'inherit',
                    backgroundColor: palette.cms?.white || '#ffffff ',
                    color: palette.cms.black || '#2f2f2f ',
                    lineHeight: '20px',
                    padding: '8px 20px',
                    border: `1px solid ${palette.cms?.black || '#2f2f2f '}`,
                    margin: '0px ',
                    textTransform: 'capitalize',
                    '&:hover': {
                        backgroundColor: palette.cms?.white || '#ffffff ',
                        border: `1px solid ${palette.cms?.black || '#2f2f2f '}`,
                        color: palette.cms.black || '#2f2f2f ',
                    },
                    '@media only screen and (max-width: 600.5px) ': {
                        padding: '6px 20px',
                    },
                },
            },
        },
    },
});

export default {
    innerModal,
};
